import { render, staticRenderFns } from "./FormReadItem.vue?vue&type=template&id=7c476c09&scoped=true&"
import script from "./FormReadItem.vue?vue&type=script&lang=js&"
export * from "./FormReadItem.vue?vue&type=script&lang=js&"
import style0 from "./FormReadItem.vue?vue&type=style&index=0&id=7c476c09&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c476c09",
  null
  
)

export default component.exports